'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HistoryManager = function () {
    function HistoryManager() {
        (0, _classCallCheck3.default)(this, HistoryManager);

        this.reset();
    }

    (0, _createClass3.default)(HistoryManager, [{
        key: 'init',
        value: function init(window) {
            var _useBrowserHistory = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            this.initiated = true;
            this.useBrowserHistory = _useBrowserHistory && 'onpopstate' in window;
            this.window = window;

            if (this.useBrowserHistory) {
                this.window.addEventListener('popstate', this.dispatchPopstate.bind(this));
            }
        }
    }, {
        key: 'getState',
        value: function getState() {
            this.validate();

            if (this.useBrowserHistory) {
                return this.window.history.state;
            } else {
                return this.historyStack[this.currentIndex].state;
            }
        }
    }, {
        key: 'replaceState',
        value: function replaceState(state) {
            var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

            this.validate();
            if (this.useBrowserHistory) {
                this.window.history.replaceState(state, title);
            } else {
                this.historyStack[this.currentIndex].state = state;
                this.historyStack[this.currentIndex].title = title;
            }
            this.dispatchPopstate();
        }
    }, {
        key: 'pushState',
        value: function pushState(state) {
            var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

            this.validate();
            if (this.useBrowserHistory) {
                this.window.history.pushState(state, title);
            } else {
                this.historyStack.splice(this.currentIndex + 1, this.historyStack.length - this.currentIndex - 1, {
                    state: state,
                    title: title
                });
                this.currentIndex = this.historyStack.length - 1;
            }
            this.dispatchPopstate();
        }
    }, {
        key: 'go',
        value: function go(delta) {
            this.validate();
            if (this.useBrowserHistory) {
                this.window.history.go(delta);
            } else {
                this.currentIndex += delta;
                this.dispatchPopstate();
            }
        }
    }, {
        key: 'onPopstate',
        value: function onPopstate(callback) {
            this.validate();
            this.popstateListeners.push(callback);
        }
    }, {
        key: 'dispatchPopstate',
        value: function dispatchPopstate() {
            var _this = this;

            this.validate();
            this.popstateListeners.forEach(function (callback) {
                callback({ state: _this.getState() });
            });
        }
    }, {
        key: 'reset',
        value: function reset() {
            this.initiated = false;
            this.popstateListeners = [];
            this.useBrowserHistory = true;
            this.currentIndex = 0;
            this.historyStack = [{ state: {}, title: '' }];
        }
    }, {
        key: 'validate',
        value: function validate() {
            if (!this.initiated) {
                throw new Error('HistoryManager must be initialized first');
            }
        }
    }]);
    return HistoryManager;
}();

var historyManager = new HistoryManager();

exports.default = historyManager;